import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';

const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        accent: '#1976d2',
      }
    }
  },
  icons: {
    iconfont: 'mdi',
  },
});

Vue.use(Vuetify);

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'md'
});

export default vuetify;